import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '@odo/shared-ui';
import { safeHref } from '../../../../utils/safeHref';
import { TOOLTIP_OVER_MODAL } from '../../../shared/ModalShell';
import { actionButtonClass } from './browserStyles';

interface MyIteroLinkProps {
    viewerUrl: string | null;
    className?: string;
}

export function MyIteroLink({
    viewerUrl,
    className = actionButtonClass('secondary', 'sm')
}: MyIteroLinkProps) {
    const href = safeHref(viewerUrl);
    if (!href) return null;
    return (
        <Tooltip content="Needs a myitero.com login" className={TOOLTIP_OVER_MODAL}>
            <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
                Open in myiTero
                <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" aria-hidden="true" />
                <span className="sr-only">(opens in a new tab)</span>
            </a>
        </Tooltip>
    );
}
